export default "skymp5-front/0f9cfb85776afd58699b356784a0be53.gif";